module.exports = __webpack_public_path__ + "img/chatGPT.ed712e92.webp";